/* eslint-disable max-statements */
import React, { useState, useEffect } from "react";
import styles from "./styles.css";

import PropTypes from "prop-types";
import CarConditionContent from "./car-condition-content";
import InspectionReportPopup from "../quality-promise-inspection-report-modal";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import GreenShield from "./images/green-shield.svg";
const Cars24CarCondition = ({
    content,
    inspectionReportData = {},
    config,
    fetchInspectionReportDataConnect,
    warrantyPlanInfo = {}
}) => {
    const {buyWithConfidence = [], appointmentId} = content;
    const [showInspectionReportModal, setShowInspectionReportModal] = useState(false);
    const [selectedInspectionCategoryData, setSelectedInspectionCategoryData] = useState([]);

    const { extendedWarranty = {}} = warrantyPlanInfo || {};

    const plans = extendedWarranty && extendedWarranty.plans || [];

    const handleReportClick = async(option) => {
        setSelectedInspectionCategoryData(option);
        setShowInspectionReportModal(!showInspectionReportModal);
        await yieldToMain();
    };

    const handleReportClose = () => {
        setShowInspectionReportModal(false);
    };
    useEffect(() => {
        if (appointmentId) {
            fetchInspectionReportDataConnect(appointmentId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId]);
    const { report = {} } = inspectionReportData || {};
    const { detailReport = [] } = report || {};
    return (
        <div styleName={"styles.outer"}>
            <CarConditionContent
                onClick={handleReportClick}
                inspectionReportData={inspectionReportData || {}}
                buyWithConfidence={buyWithConfidence}
                config={config}
                plans={plans}
                selectedInspectionCategoryData={selectedInspectionCategoryData}
                detailReport={detailReport}
            />
            {
                showInspectionReportModal &&
                <InspectionReportPopup
                    onClose={handleReportClose}
                    inspectionReportData={inspectionReportData || {}}
                    selectedInspectionCategoryData={selectedInspectionCategoryData} />}
            <div styleName={"styles.bottomStrip"}>
                <p>
                    <img src={GreenShield} alt="Green Shield" />This vehicle has cleared our 300 point car inspection</p>
            </div>
        </div>
    );
};

Cars24CarCondition.propTypes = {
    content: PropTypes.array,
    inspectionReportData: PropTypes.bool,
    config: PropTypes.object,
    fetchInspectionReportDataConnect: PropTypes.object,
    warrantyPlanInfo: PropTypes.object
};

export default Cars24CarCondition;
